/**
 * The one formatter for a single reseller amount beside its own currency (the money rule,
 * TMMRSL-0031 — see `PerCurrency.tsx`): `minor` in `currency`, never another row's.
 */
import { formatMoneyMicro, formatMoneyMinor } from '@/i18n/format';

/**
 * `minor` in `currency`, or `fallback` when the currency is blank or unknown to Intl. `signed`
 * shows an explicit plus sign on a positive amount.
 */
export function moneyIn(
  minor: number,
  currency: string,
  locale: string,
  fallback: string,
  signed = false,
): string {
  if (!currency) return fallback;
  try {
    return formatMoneyMinor(minor, currency, locale, signed ? { signDisplay: 'exceptZero' } : {});
  } catch {
    return fallback;
  }
}

/**
 * An amount with Intl's true sign, and an explicit `+` on a credit (`signDisplay: 'exceptZero'`).
 * `dash` when the currency is blank or unknown to Intl. Zero has no sign.
 */
export function formatSignedMoney(
  minor: number,
  currency: string,
  locale: string,
  dash: string,
): string {
  return moneyIn(minor, currency, locale, dash, true);
}

/** `micro` in `currency` (rounded to its minor unit), or `fallback` when the currency is blank or unknown to Intl. */
export function moneyMicroIn(
  micro: number,
  currency: string,
  locale: string,
  fallback: string,
): string {
  if (!currency) return fallback;
  try {
    return formatMoneyMicro(micro, currency, locale);
  } catch {
    return fallback;
  }
}
